namespace HA {

    import HANotification = HA.Core.Notification.HANotification;
    import Data = HA.Core.Repository.Data;
    import IWebPageService = HA.Core.Service.IWebPageService;
    export let APPSERVICE: HA.Core.Service.App;
    export let SERVICE4APP: any;
    export let DATAREPO: Data;
    export let NOTIFICATION: HANotification;
    export let HAAPPID: string;
    export let IMG_OBSERVER = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {

            if (entry.isIntersecting) {
                const image = (entry.target as HTMLImageElement);
                image.src = image.dataset.src;
                IMG_OBSERVER.unobserve(image);
            }
        });
    });

    export function getDataRepository(): Data {
        if (!DATAREPO) {
            DATAREPO = new HA.Core.Repository.Data();
        }

        return DATAREPO;
    }

    export function getService(id: string) {
        return getAppService().getService(id);
    }

    export function getWebPageService(): IWebPageService {
        return getAppService().getWebPageService();
    }

    export function setAppService(appService: HA.Core.Service.App) {
        APPSERVICE = appService;
    }

    export function getAppService(): HA.Core.Service.App {
        return APPSERVICE;
    }

    export function setService4App(appService) {
        SERVICE4APP = appService;
    }

    export function getService4App() {
        return SERVICE4APP;
    }

    export function timeout(func: () => void, time: number) {
        return setTimeout(func, time);
    }

    /**
     *
     * @param notification
     */
    export function setNotification(notification: HANotification) {
        NOTIFICATION = notification;
    }

    /**
     *
     * @param msg
     */
    export function log(msg: any) {
        if (NOTIFICATION) {
            NOTIFICATION.log(msg);
        } else {
            log2([isDebug(), msg]);
        }
    }

    export function log2(msg: any) {
        console.log(msg);
    }

    export function setAppId(id: string) {
        HAAPPID = id;
    }

    export function getAppId(): string {
        return HAAPPID;
    }

    export function lazyloadImage(img: HTMLImageElement) {
        IMG_OBSERVER.observe(img);
    }

    /**
     *
     * @param msg
     */
    export function notifyUser(msg: any) {
        log(msg);
    }

    /**
     *
     * @returns {boolean}
     */
    export function isDebug() {
        if (NOTIFICATION) {
            return NOTIFICATION.isDebug();
        }

        return false;
    }

    /**
     *
     * @param namespace
     * @param serviceName
     * @param data
     */
    export function createService(namespace: any, serviceName: string, data: any) {
        try {
            return new (namespace)[serviceName](data);
        } catch (e) {
            throw e;
        }
    }

    /**
     *
     * @param data
     */
    export function ptime(...data: any) {
        log2("time:");
        const date = new Date();
        log2(date.getMilliseconds() + " - " + date.toUTCString());
        if (data) {
            log2(data);
        }
    }

    /**
     *
     * @param data
     * @returns {any}
     */
    export function toObj(data: Map<any, any>) {
        const obj = Object.create(null);
        if (data instanceof Map) {
            data.forEach((v: any, k: any) => {
                obj[k] = v;
            });
        }

        return obj;
    }


    export function toMap(data: Map<any, any> | any, map?: Map<any, any>): Map<any, any> {

        map = map || new Map();
        if (data instanceof Map) {
            data.forEach((v: any, k: any) => {
                map.set(k, v);
            });
        } else {
            if (data) {
                Object.keys(data).forEach((key) => {
                    map.set(key, data[key]);
                });
            }
        }

        return map;
    }
}
